export default __webpack_public_path__ + "static/media/close-white.239ce48e.svg";